
import React from "react";
import { usePlacesWidget } from "react-google-autocomplete";

const AutoCompleteAddress = ({ name, value, onChange, placeholder,errorMessage = null,
  errorMessagePosition = "bottom",
  placeTypes = [], // e.g. ['(cities)']
  country = null,
  onlyCountry = false,
  showState = false,
  onlyCity = false,
  combineCityCountry=false,
  onSelect = null, // new optional callback: receives parsed address object
  inputStyle = {}, // optional style overrides for the input (e.g. to match adjacent field heights)
}) => {

  const parseAddressComponents = (place) => {
    const comps = place?.address_components || [];
    const map = {};
    comps.forEach((c) => {
      c.types.forEach((t) => {
        if (!map[t]) map[t] = c.long_name;
      });
    });

    let lat = null;
    let lng = null;
    if (place?.geometry?.location) {
      const loc = place.geometry.location;
      lat = typeof loc.lat === "function" ? loc.lat() : loc.lat;
      lng = typeof loc.lng === "function" ? loc.lng() : loc.lng;
    }

    return {
      formatted_address: place?.formatted_address || "",
      street_number: map.street_number || null,
      route: map.route || null,
      street: [map.street_number, map.route].filter(Boolean).join(" ") || null,
      sublocality: map.sublocality || null,
      locality: map.locality || map.postal_town || null,
      administrative_area_level_2: map.administrative_area_level_2 || null,
      administrative_area_level_1: map.administrative_area_level_1 || null,
      postal_code: map.postal_code || null,
      country: map.country || null,
      country_code: place?.address_components?.find(c => c.types.includes('country'))?.short_name || null,
      lat,
      lng,
      place_id: place?.place_id || null,
      raw: place,
    };
  };

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => {
      const parsed = parseAddressComponents(place);

      if (onSelect && typeof onSelect === 'function') {
        onSelect(parsed);
      }

      if(onlyCountry){
        if (parsed.country) {
          onChange(name, parsed.country); // Just the country name
        } else {
          onChange(name, ""); // fallback if not found
        }
      } else if(showState){
        if (parsed.administrative_area_level_1) {
          onChange(name, parsed.administrative_area_level_1);
        } else {
          onChange(name, "");
        }
      } else if(onlyCity){
        if (parsed.locality) {
          onChange(name, parsed.locality);
        } else {
          onChange(name, "");
        }
      } else if (combineCityCountry) {
        const combinedValue = [
          parsed.locality,
          parsed.country,
        ].filter(Boolean).join(", ");

        onChange(name, combinedValue);
      } else {
        onChange(name, parsed.formatted_address || "");
      }
    },
    options: {
      types: placeTypes,
      ...(country && { componentRestrictions: { country } }),
    },
  });

  const handleInputChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <>
    {errorMessage && errorMessagePosition === "top" && (
        <p className="text-red text-xs mb-0.5">* {errorMessage}</p>
      )}
    <input
      ref={ref}
      className="input-class w-full"
      type="text"
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={handleInputChange}
      style={{
        padding: "1rem",
        ...inputStyle,
      }}
    />
    {errorMessage && errorMessagePosition === "bottom" && (
        <p className="text-red text-xs mb-0.5">* {errorMessage}</p>
      )}
    </>
  );
};

export default AutoCompleteAddress;
